var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.visible)?_c('show-model',{attrs:{"title":_vm.modelTitle,"text":_vm.modelText,"confirmText":_vm.confirmText},on:{"change":_vm.confirmModel,"cancel":_vm.cancelModel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }